var exports = {
  "kL": "ScopeSheet.module__container___amZKQ0",
  "XG": "ScopeSheet.module__scroller___amZKQ0",
  "iy": "ScopeSheet.module__optionsContainer___amZKQ0",
  "uK": "ScopeSheet.module__option___amZKQ0",
  "h4": "ScopeSheet.module__optionSelected___amZKQ0",
  "ts": "ScopeSheet.module__optionLeft___amZKQ0",
  "H9": "ScopeSheet.module__optionIcon___amZKQ0",
  "AJ": "ScopeSheet.module__optionIconSelected___amZKQ0",
  "re": "ScopeSheet.module__optionText___amZKQ0",
  "ed": "ScopeSheet.module__optionLabel___amZKQ0",
  "tD": "ScopeSheet.module__optionLabelSelected___amZKQ0",
  "q3": "ScopeSheet.module__optionDescription___amZKQ0",
  "oE": "ScopeSheet.module__checkIcon___amZKQ0",
};

module.exports = exports;
